export default {
  id: 'data-management',
  title: 'Data Management',
  category: 'Admin',
  summary: 'Perform bulk charge-code reassignment for an employee over a date range.',
  overview: 'Data Management provides administrative tools for correcting historical time charging — for example when work was entered against the wrong charge code.',
  howItWorks: [
    'Select an employee and a date range.',
    'Choose the source and target charge codes.',
    'Reassignment updates historical entries so reporting and billing reflect the corrected code.'
  ],
  actions: [
    {
      name: 'Reassign charge codes',
      description: 'Moves an employee’s time entries from one charge code to another for the selected dates. This can affect reports and uninvoiced/billable history.'
    }
  ],
  tips: [
    'Preview the impact carefully — bulk reassignment changes historical records.',
    'Coordinate with invoicing so you do not alter time that was already billed without a deliberate plan.'
  ],
  related: ['charge-codes', 'timesheet', 'invoices']
};



// WEBPACK FOOTER //
// ./client/help/content/data-management.js